import React, { Dispatch, SetStateAction, useMemo } from "react";
import styles from "./quick-select.module.scss";
import { Button } from "@mui/material";
import clsx from "clsx";
import { DateTime } from "luxon";

export interface IQuickSelectProps {
  initial: DateTime;
  value: DateTime; // UTC milliseconds
  onChange: (value: DateTime) => void;
  className?: string;
}

export function QuickSelect(props: IQuickSelectProps) {
  const TOLERANCE_SECONDS = 60;
  const options = [
    { label: "5m ago", duration: { minutes: 5 } },
    { label: "15m ago", duration: { minutes: 15 } },
    { label: "30m ago", duration: { minutes: 30 } },
    { label: "1h ago", duration: { hours: 1 } },
    { label: "2h ago", duration: { hours: 2 } },
    { label: "3h ago", duration: { hours: 3 } },
    { label: "4h ago", duration: { hours: 4 } },
  ];

  const selectedLabel = useMemo(() => {
    return options.find((opt) => {
      const expected = props.initial.minus(opt.duration);

      const diffInSeconds = Math.abs(
        expected.diff(props.value, "seconds").seconds,
      );

      return diffInSeconds <= TOLERANCE_SECONDS;
    })?.label;
  }, [props.value, props.initial]);

  return (
    <div className={clsx(props.className, styles.container)}>
      {options.map(({ label, duration }) => (
        <Button
          key={label}
          variant="text"
          className={clsx(styles.button, {
            [styles["button--selected"]]: selectedLabel === label,
          })}
          onClick={() => {
            props.onChange(props.initial.minus(duration));
          }}
        >
          {label}
        </Button>
      ))}
    </div>
  );
}
